import { $elParent } from 'src/scripts/utils/utils'
import { ShopComponent } from '.'
import { SidebarFilters } from './sidebar-filters'

const SHOP_SELECTOR = 'shop-component'

export class SidebarFiltersDesktop extends SidebarFilters {
  handleSectionLoad = (): void => {}

  change(): void {
    const shop: ShopComponent = $elParent(SHOP_SELECTOR, this)

    if (shop) {
      this.createQuery()
      shop.updateBySearchParams(this.searchParams)
    }
  }
}
